// ============================================================================
// CHAT（聊天）相关 Selectors
// ============================================================================

import { atom } from 'jotai'

import { chatRoomsRawAtom, messagesAtomFamily } from './AtomChats'
import { selectedChatRoomIdAtom } from '../../contexts/AtomUtil'
import { transformServerRooms } from '../../utils/chatUtils'
import { usersAtom } from '../user/AtomUsers'
import { currentUserAtom } from '../user/AtomUsers'

/**
 * Selector atom for messages of the currently selected room
 * Uses selectedChatRoomIdAtom (from URL) to determine which room's messages to return
 * Returns empty array if no room is selected
 *
 * This selector automatically recalculates when:
 * - The selected room ID changes (from URL)
 * - Messages for the selected room are updated
 *
 * Usage:
 *   const selectedMessages = useAtomValue(selectedMessagesAtom)
 */
export const selectedMessagesAtom = atom((get) => {
  // Get the currently selected room ID from URL (selectedChatRoomIdAtom reads from URL params)
  const selectedRoomId = get(selectedChatRoomIdAtom)

  // Return empty array if no room is selected
  if (!selectedRoomId) {
    return []
  }

  // Get messages atom for the selected room using atom family
  // This ensures we get the correct messages array for the selected room
  const roomMessagesAtom = messagesAtomFamily(selectedRoomId)

  // Return messages for the selected room
  // The atom family automatically handles the roomId -> messages mapping
  return get(roomMessagesAtom)
})

export const chatRoomUsersAtom = atom((get) => {
  const chatRoomsRaw = get(chatRoomsRawAtom)
  // Merge all userIds across rooms and lastMessage.senderId into a unique set
  const userIds = new Set(chatRoomsRaw.flatMap((room) => [...(room.userId ?? []), room.lastMessage?.senderId]).filter(Boolean))

  // This is a map
  const users = get(usersAtom)

  return Array.from(userIds)
    .map((userId) => users[userId])
    .filter((user) => user != null)
})

// Create from chatRoomsRaw
export const conversationsAtom = atom((get) => {
  const chatRoomsRaw = get(chatRoomsRawAtom)
  const chatRoomUsers = get(chatRoomUsersAtom)
  const currentUser = get(currentUserAtom)

  if (currentUser == null || chatRoomUsers == null || chatRoomsRaw == null) {
    return []
  }

  const transformedRooms = transformServerRooms(chatRoomsRaw, currentUser.resourceId, chatRoomUsers)
  console.log('transformedRooms =>', transformedRooms)

  return transformedRooms
})
